import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import "./Home.css";
import HorizontalCarousel from "../../components/common/productcarouselComponent/Index.jsx";
import ProductBanner from "../../components/Home/ProductShowcase/ProductShowcase.jsx";
import ReviewCard from "../../components/Home/Testimonials/Index.jsx";
import BannerComponent from "../../components/common/BannerComponent/Index.jsx";
import ProductViewModal from "../../components/common/modalComponent/productModal/index.jsx";
import Spinner from "../../components/common/loadingSpinnercomponent/Spinner.jsx";
import { fetchProducts } from "../../slices/ProductSlice";
import { fetchAllHomeImages } from "../../Services/HomeServices"; 
import { Image_URL } from "../../config/config.js";

const Home = () => {
  const dispatch = useDispatch();
  const { products, loading, error } = useSelector((state) => state.product);
  const [showCookieMessage, setShowCookieMessage] = useState(false); // Initialize as false
  const [banners, setBanners] = useState([]);
  const [sliders, setSliders] = useState([]);
  const [imagesLoading, setImagesLoading] = useState(true);
  const [imagesError, setImagesError] = useState(null);

  useEffect(() => {
    // Check localStorage when component mounts
    const hasSeenCookieMessage = localStorage.getItem('cookieMessageDismissed');
    if (!hasSeenCookieMessage) {
      setShowCookieMessage(true);
    }

    const loadHomeImages = async () => {
      try {
        const images = await fetchAllHomeImages();
        setBanners(images.banners);
        setSliders(images.sliders);
        setImagesLoading(false);
      } catch (error) {
        setImagesError("Failed to load home images.");
        setImagesLoading(false);
      }
    };

    loadHomeImages();
    dispatch(fetchProducts());
  }, [dispatch]);

  const handleDismissCookieMessage = () => {
    setShowCookieMessage(false);
    // Set localStorage flag with no expiration
    localStorage.setItem('cookieMessageDismissed', 'true');
  };

  const reviews = [
    {
      name: "Darshika C",
      time: "A month ago",
      text: "The dresses at Jewelbox are very good quality, from the material to the color. With exceptional designs as well. Thank you Anusha for arranging to send on time.",
      avatar: "https://via.placeholder.com/50",
    }
  ];

  const activeSliders = sliders.filter(slider => slider.Status === 1);
  
  const sliderSettings = {
    dots: activeSliders.length > 1,
    infinite: activeSliders.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: activeSliders.length > 1,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: activeSliders.length > 1,
    swipe: activeSliders.length > 1,
    touchMove: activeSliders.length > 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false
        }
      }
    ]
  };

  const renderSlider = () => {
    if (activeSliders.length === 0) {
      return null;
    }

    if (activeSliders.length === 1) {
      return (
        <div className="home-header-image-container">
          <img 
            src={`${Image_URL}home-images/thumbnails/${activeSliders[0].ImagePath}`}
            alt="Featured"
            className="Header"
          />
        </div>
      );
    }

    return (
      <div className="header-image-container">
        <Slider {...sliderSettings}>
          {activeSliders.map((sliderImage, index) => {
            const imagePath = `${Image_URL}home-images/thumbnails/${sliderImage.ImagePath}`;
            return (
              <div key={sliderImage.ImageId || index} className="single-slider-image">
                <img 
                  src={imagePath} 
                  alt={`Featured ${index + 1}`} 
                  className="Header" 
                />
              </div>
            );
          })}
        </Slider>
      </div>
    );
  };

  const renderCookieMessage = () => {
    if (!showCookieMessage) return null;

    return (
      <div className="cookie-message">
        <div className="cookie-content">
          <i className="fa-solid fa-cookie-bite"></i>
          <span>
            We use cookies on this site to analyze traffic, remember your
            preferences, and optimize your experience.
          </span>
          <a href="/privacy-policy" className="learn-more">
            Learn more
          </a>
        </div>
        <button className="got-it" onClick={handleDismissCookieMessage}>
          Got it
        </button>
      </div>
    );
  };

  if (loading || imagesLoading) {
    return <Spinner />;
  }

  if (error || imagesError) {
    return (
      <div className="alert alert-danger" role="alert">
        {error || imagesError}
      </div>
    );
  }

  return (
    <div className="home-container">
      {renderSlider()}
      {renderCookieMessage()}

      <div className="container">
        <h1 className="heading-style">New Arrivals</h1>
        <HorizontalCarousel products={products} />

        <ProductBanner banners={banners} />

        <h1 className="heading-style Best-selling">Best Selling</h1>
        <HorizontalCarousel products={products} />

        <section className="testimonials-section">
          <h1 className="heading-style testimonial-title">Testimonials</h1>
          <a href="/testimonials" className="view-all">view all</a>
          <div className="testimonial">
            <div className="row">
              {reviews.length > 0 ? (
                reviews.map((review, index) => (
                  <div className="col-md-12" key={index}>
                    <ReviewCard review={review} />
                  </div>
                ))
              ) : (
                <p className="no-testimonials">No testimonials available at the moment.</p>
              )}
            </div>
          </div>
        </section>
      </div>
      <BannerComponent />
    </div>
  );
};

export default Home;